<template>
  <div class="popUpWrap dark">
    <section class="popup dark basic">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5 v-html="content" />
        </div>
        <div class="btnArea">
          <button class="cancel" @click.stop="onClickClose">{{ t('common-cancel') }}</button>
          <button @click.stop="onClickResend">{{ t('common-resend') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import {ResendEmailType} from '~~/package/mapper/user/model/ResendEmailType';

const {t} = useI18n()
const dialogStore = useDialogStore();

const content = computed(() => {
  if(dialogStore.options.props.emailType === ResendEmailType.ASSESSMENT_REINVITE)
    return t('skillCertify-candidate-resend-email-description', {email: `<span>${dialogStore.options.props?.email}</span>`});
  else
    return t('organization-member-resend-email-description', {email: `<span>${dialogStore.options.props?.email}</span>`});
})

const onClickClose = () => {
    dialogStore.close();
};

const onClickResend = () => {
  dialogStore.options.confirm?.event();
  onClickClose();
}
</script>

